<template>
  <VaCard stripe stripe-color="success">
    <VaCardTitle>
      Отчеты
    </VaCardTitle>
    <VaTabs
        v-model="reportType"
        grow
        :disabled="loading"
      >
        <template #tabs>
          <VaTab>
            Амбулаторные приемы
          </VaTab>
          <VaTab>
            Выписки
          </VaTab>
          <VaTab>
            Стационарный журнал
          </VaTab>
          <VaTab>
            Журнал операций
          </VaTab>
        </template>
      </VaTabs>
      <Transition :name="slideDirection">
        <VaCardContent v-if="reportType==0">
          <VaCardTitle>Амбулаторные приемы</VaCardTitle>
          <div style="display: flex; flex-direction: column; max-width:600px">
            <label class="va-input-label" style="color: var(--va-primary);">Временной интервал (по дате приема)</label>
            <div class="rc-flex row vcenter">
              <VaDateInput v-model="filter.visits.dateMin" class="mr-2"/>
              <VaIcon name="arrow_right_alt" color="info" class="mr-2"/>
              <VaDateInput v-model="filter.visits.dateMax" />
            </div>
            <label class="va-input-label mb-3" style="color: var(--va-primary);">Возраст</label>
            <VaSlider
            class="mt-2"
              v-model="filter.visits.age"
              range
              track-label-visible
              :min=1
              :max=110
            >
              <template #trackLabel="{ value, order }">
                <VaChip
                  size="small"
                  :color="order === 0 ? 'success' : 'info'"
                >
                  {{ value }} {{ wordforcount(value,['год', 'года', 'лет']) }}
                </VaChip>
              </template>
            </VaSlider>
            <label class="va-input-label" style="color: var(--va-primary);">Пол</label>
            <VaRadio
              v-model="filter.visits.sex"
              :options=sexoptions
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Сельский житель</label>
            <VaRadio
              v-model="filter.visits.villager"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Платный прием</label>
            <VaRadio
              v-model="filter.visits.paid"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <div class="rc-flex row vcenter">
            <VaButton icon="table" :loading="loading" class="mt-2 mb-4 mr-2" preset="primary" @click="getReportVisits(true, true)">Сформировать</VaButton>
            <VaBadge color="success" overlap text="xlsx" placement="top-end" offset="8">
              <VaButton icon="file_download" :loading="isExporting" class="mt-2 mb-4" preset="primary" @click="downloadReport()">Скачать отчет</VaButton>
            </VaBadge>
            </div>
            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-if="et[reportType]>0"
              >
              Запрос выполнен за {{et[reportType]}} {{wordforcount(reportLength.visits,['секунду', 'секунды', 'секунд'])}}. Всего в выборке: {{ reportLength.visits }} {{ wordforcount(reportLength.visits,['запись', 'записи', 'записей']) }}
            </span>
            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-else-if="loading===true"
              >
                Запрос выполняется...
          </span>
            </div>
            <VaDataTable
              v-if="reportVisits.length>0"
              :items="reportVisits"
              :columns="columns.visits"
              sticky-header
              hoverable
              :loading="loading"
            >
              <template #cell(visitDate)="{ rowData }">{{ rowData.visitDate.split(" ")[0] }}</template>
              <template #cell(diagnosis)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.diagnosis.length>12" style="max-width:50vw">
                  {{ rowData.diagnosis.slice(0,10) }}...
                  <template #body>{{rowData.diagnosis}}</template>
                </VaPopover>
                <span v-else>{{ rowData.diagnosis }}</span>
              </template>
              <template #cell(mkb10)="{ rowData }">
                
                <VaPopover placement="right" v-if="rowData.mkb10.length>12">
                  {{ rowData.mkb10.slice(0,12) }}...
                  <template #body>{{ rowData.mkb10 }}</template>
                </VaPopover>
                <span v-else>{{ rowData.mkb10 }}</span>
              </template>
              <template #cell(patient_sex)="{ rowData }">{{ sex_str[rowData.patient_sex] }}</template>
              <template #cell(patient_villager)="{ rowData }"> {{ rowData.patient_villager === "True" ? 'Да' : "Нет" }} </template>
              <template #cell(paid)="{ rowData }"> {{ rowData.paid === true ? 'Платный' : "Нет" }} </template>
            </VaDataTable>
            <VaPagination
              v-if="reportLength.visits>0 && pages.visits > 1"
              v-model="filter.visits.page"
              :pages="pages.visits"
              :visible-pages="3"
              buttons-preset="secondary"
              class="justify-center sm:justify-start"
            />
        </VaCardContent>

        <VaCardContent v-else-if="reportType==1">
          <VaCardTitle>Выписки</VaCardTitle>
          <div style="display: flex; flex-direction: column; max-width:600px">
            <label class="va-input-label" style="color: var(--va-primary);">Временной интервал (по дате выписки)</label>
            <div class="rc-flex row vcenter">
              <VaDateInput v-model="filter.discharge.dateMin" class="mr-2"/>
              <VaIcon name="arrow_right_alt" color="info" class="mr-2"/>
              <VaDateInput v-model="filter.discharge.dateMax" />
            </div>
            <label class="va-input-label mb-3" style="color: var(--va-primary);">Возраст</label>
            <VaSlider
            class="mt-2"
              v-model="filter.discharge.age"
              range
              track-label-visible
              :min=1
              :max=110
            >
              <template #trackLabel="{ value, order }">
                <VaChip
                  size="small"
                  :color="order === 0 ? 'success' : 'info'"
                >
                  {{ value }} {{ wordforcount(value,['год', 'года', 'лет']) }}
                </VaChip>
              </template>
            </VaSlider>
            <label class="va-input-label" style="color: var(--va-primary);">Пол</label>
            <VaRadio
              v-model="filter.discharge.sex"
              :options=sexoptions
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Сельский житель</label>
            <VaRadio
              v-model="filter.discharge.villager"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Платный прием</label>
            <VaRadio
              v-model="filter.discharge.paid"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <div class="rc-flex row vcenter">
              <VaButton icon="table" :loading="loading" class="mt-2 mb-4 mr-2" preset="primary" @click="getReportDischarge(true)">Сформировать</VaButton>
              <VaBadge color="success" overlap text="xlsx" placement="top-end" offset="8">
                <VaButton icon="file_download" :loading="isExporting" class="mt-2 mb-4" preset="primary" @click="downloadReport()">Скачать отчет</VaButton>
              </VaBadge>
            </div>

            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-if="et[reportType]>0"
              >
              Запрос выполнен за {{et[reportType]}} {{wordforcount(reportLength.discharge,['секунду', 'секунды', 'секунд'])}}. Всего в выборке: {{ reportLength.discharge }} {{ wordforcount(reportLength.discharge,['запись', 'записи', 'записей']) }}
            </span>
            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-else-if="loading===true"
              >
                Запрос выполняется...
          </span>
            </div>
            <VaDataTable
              v-if="reportDischarge.length>0"
              :items="reportDischarge"
              :columns="columns.discharge"
              sticky-header
              hoverable
              :loading="loading"
            >
              <template #cell(discharge_date)="{ rowData }">{{ new Date(rowData.discharge_date.split(" ")[0]).toLocaleDateString() }}</template>
              <template #cell(diagnosis)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.diagnosis.length>12" style="max-width:50vw">
                  {{ rowData.diagnosis.slice(0,10) }}...
                  <template #body>{{rowData.diagnosis}}</template>
                </VaPopover>
                <span v-else>{{ rowData.diagnosis }}</span>
              </template>
              <template #cell(patient_sex)="{ rowData }">{{ sex_str[rowData.patient_sex] }}</template>
              <template #cell(patient_villager)="{ rowData }"> {{ rowData.patient_villager === "True" ? 'Да' : "Нет" }} </template>
              <template #cell(paid)="{ rowData }"> {{ rowData.paid == "True" ? 'Платный' : "Нет" }} </template>
            </VaDataTable>
            <VaPagination
              v-if="reportLength.discharge>0 && pages.discharge > 1"
              v-model="filter.discharge.page"
              :pages="pages.discharge"
              :visible-pages="3"
              buttons-preset="secondary"
              class="justify-center sm:justify-start"
            />
        </VaCardContent>

        <VaCardContent v-else-if="reportType==2">
          <VaCardTitle>Стационарный журнал</VaCardTitle>
          <div style="display: flex; flex-direction: column; max-width:600px">
            <label class="va-input-label" style="color: var(--va-primary);">Временной интервал (по дате выписки)</label>
            <div class="rc-flex row vcenter">
              <VaDateInput v-model="filter.journal.dateMin" class="mr-2"/>
              <VaIcon name="arrow_right_alt" color="info" class="mr-2"/>
              <VaDateInput v-model="filter.journal.dateMax" />
            </div>

            <VaSelect
                :disabled="filter.journal.ksg.length>0"
                style="width:100%"
                v-model="filter.journal.code"
                class="col-span-1 mb-2"
                label="Код операции"
                placeholder="Найти код..."
                noOptionsText="Нет совпадений"
                autocomplete
                clearable
                highlight-matched-text
                :options="codes"
                :textBy="(option) => option.operationCode"
                :valueBy="(option) => option.operationCode"
              />
              <label class="va-input-label" style="color: var(--va-primary);">Или</label>
              <VaSelect
                :disabled="filter.journal.code.length>0"
                style="width:100%"
                v-model="filter.journal.ksg"
                class="col-span-1 mb-2"
                label="Код КСГ"
                placeholder="Найти код КСГ..."
                noOptionsText="Нет совпадений"
                autocomplete
                clearable
                highlight-matched-text
                :options="codes"
                :textBy="(option) => option.operationCodeKSG"
                :valueBy="(option) => option.operationCodeKSG"
              />


            <label class="va-input-label mb-3" style="color: var(--va-primary);">Возраст</label>
            <VaSlider
              class="mt-2"
              v-model="filter.journal.age"
              range
              track-label-visible
              :min=1
              :max=110
            >
              <template #trackLabel="{ value, order }">
                <VaChip
                  size="small"
                  :color="order === 0 ? 'success' : 'info'"
                >
                  {{ value }} {{ wordforcount(value,['год', 'года', 'лет']) }}
                </VaChip>
              </template>
            </VaSlider>
            <label class="va-input-label" style="color: var(--va-primary);">Пол</label>
            <VaRadio
              v-model="filter.journal.sex"
              :options=sexoptions
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Сельский житель</label>
            <VaRadio
              v-model="filter.journal.villager"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Платный прием</label>
            <VaRadio
              v-model="filter.journal.paid"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <div class="rc-flex row vcenter">
              <VaButton icon="table" :loading="loading" class="mt-2 mb-4 mr-2" preset="primary" @click="getReportJournal(true)">Сформировать</VaButton>
              <VaBadge color="success" overlap text="xlsx" placement="top-end" offset="8">
                <VaButton icon="file_download" :loading="isExporting" class="mt-2 mb-4" preset="primary" @click="downloadReport()">Скачать отчет</VaButton>
              </VaBadge>
            </div>

            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-if="et[reportType]>0"
              >
              Запрос выполнен за {{et[reportType]}} {{wordforcount(reportLength.journal,['секунду', 'секунды', 'секунд'])}}. Всего в выборке: {{ reportLength.journal }} {{ wordforcount(reportLength.journal,['запись', 'записи', 'записей']) }}
            </span>
            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-else-if="loading===true"
              >
                Запрос выполняется...
          </span>
            </div>
            <VaDataTable
              v-if="reportLength.journal>0"
              :items="reportJournal"
              :columns="columns.journal"
              sticky-header
              hoverable
              :loading="loading"
            >
              <template #cell(openDate)="{ rowData }">{{ new Date(rowData.openDate.split(" ")[0]).toLocaleDateString() }}</template>
              <template #cell(discharge_date)="{ rowData }">{{ new Date(rowData.discharge_date.split(" ")[0]).toLocaleDateString() }}</template>
              <template #cell(diagnosis)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.diagnosis.length>12" style="max-width:50vw">
                  {{ rowData.diagnosis.slice(0,10) }}...
                  <template #body>{{rowData.diagnosis}}</template>
                </VaPopover>
                <span v-else>{{ rowData.diagnosis }}</span>
              </template>
              <template #cell(operationName)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.operationName.length>12" style="max-width:50vw">
                  {{ rowData.operationName.slice(0,10) }}...
                  <template #body>{{rowData.operationName}}</template>
                </VaPopover>
                <span v-else>{{ rowData.operationName }}</span>
              </template>
              <template #cell(xray_image)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.xray_image.image" style="max-width:50vw">
                  {{ rowData.xray_image.date }}
                  <template #body>
                    <p>Загрузил: {{ rowData.xray_image.user_full_name }}</p>
                    <p>Описание: {{ rowData.xray_image.comment.length > 0 ? rowData.xray_image.comment.length : 'отсутствует' }}</p>
                  </template>
                </VaPopover>
                <span v-else>Нет</span>
              </template>
              <template #cell(patient_sex)="{ rowData }">{{ sex_str[rowData.patient_sex] }}</template>
              <template #cell(patient_villager)="{ rowData }"> {{ rowData.patient_villager === "True" ? 'Да' : "Нет" }} </template>
              <template #cell(paid)="{ rowData }"> {{ rowData.paid == "True" ? 'Платный' : "Нет" }} </template>
            </VaDataTable>

            <VaPagination
              v-if="reportLength.journal>0 && pages.journal > 1"
              v-model="filter.journal.page"
              :pages="pages.journal"
              :visible-pages="3"
              buttons-preset="secondary"
              class="justify-center sm:justify-start"
            />
        </VaCardContent>

        <VaCardContent v-else-if="reportType==3">
          <VaCardTitle>Журнал операций</VaCardTitle>
          <div style="display: flex; flex-direction: column; max-width:600px">
            <label class="va-input-label" style="color: var(--va-primary);">Временной интервал (по дате операции)</label>
            <div class="rc-flex row vcenter">
              <VaDateInput v-model="filter.operations.dateMin" class="mr-2"/>
              <VaIcon name="arrow_right_alt" color="info" class="mr-2"/>
              <VaDateInput v-model="filter.operations.dateMax" />
            </div>

            <VaSelect
                :disabled="filter.operations.ksg.length>0"
                style="width:100%"
                v-model="filter.operations.code"
                class="col-span-1 mb-2"
                label="Код операции"
                placeholder="Найти код..."
                noOptionsText="Нет совпадений"
                autocomplete
                clearable
                highlight-matched-text
                :options="codes"
                :textBy="(option) => option.operationCode"
                :valueBy="(option) => option.operationCode"
              />
              <label class="va-input-label" style="color: var(--va-primary);">Или</label>
              <VaSelect
                :disabled="filter.operations.code.length>0"
                style="width:100%"
                v-model="filter.operations.ksg"
                class="col-span-1 mb-2"
                label="Код КСГ"
                placeholder="Найти код КСГ..."
                noOptionsText="Нет совпадений"
                autocomplete
                clearable
                highlight-matched-text
                :options="codes"
                :textBy="(option) => option.operationCodeKSG"
                :valueBy="(option) => option.operationCodeKSG"
              />


            <label class="va-input-label mb-3" style="color: var(--va-primary);">Возраст</label>
            <VaSlider
              class="mt-2"
              v-model="filter.operations.age"
              range
              track-label-visible
              :min=1
              :max=110
            >
              <template #trackLabel="{ value, order }">
                <VaChip
                  size="small"
                  :color="order === 0 ? 'success' : 'info'"
                >
                  {{ value }} {{ wordforcount(value,['год', 'года', 'лет']) }}
                </VaChip>
              </template>
            </VaSlider>
            <label class="va-input-label" style="color: var(--va-primary);">Пол</label>
            <VaRadio
              v-model="filter.operations.sex"
              :options=sexoptions
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Сельский житель</label>
            <VaRadio
              v-model="filter.operations.villager"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
            />
            <label class="va-input-label" style="color: var(--va-primary);">Платный прием</label>
            <VaRadio
              v-model="filter.operations.paid"
              :options=options
              :textBy="(option) => option.text"
              :valueBy="(option) => option.value"
              class="mb-2"
            />
            <div class="rc-flex row vcenter">
              <VaButton icon="table" :loading="loading" class="mt-2 mb-4 mr-2" preset="primary" @click="getReportOperations(true)">Сформировать</VaButton>
              <VaBadge color="success" overlap text="xlsx" placement="top-end" offset="8">
                <VaButton icon="file_download" :loading="isExporting" class="mt-2 mb-4" preset="primary" @click="downloadReport()">Скачать отчет</VaButton>
              </VaBadge>
            </div>

            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-if="et[reportType]>0"
              >
              Запрос выполнен за {{et[reportType]}} {{wordforcount(reportLength.operations,['секунду', 'секунды', 'секунд'])}}. Всего в выборке: {{ reportLength.operations }} {{ wordforcount(reportLength.operations,['запись', 'записи', 'записей']) }}
            </span>
            <span
              color="secondary"
              border="left"
              class="mb-2"
              v-else-if="loading===true"
              >
                Запрос выполняется...
          </span>
            </div>
            <VaDataTable
              v-if="reportLength.operations>0"
              :items="reportOperations"
              :columns="columns.operations"
              sticky-header
              hoverable
              :loading="loading"
            >
              <template #cell(operationEnd)="{ rowData }">{{ rowData.operationEnd.toString().split(" ")[0] }}</template>
              <template #cell(diagnosis)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.diagnosis.length>12" style="max-width:50vw">
                  {{ rowData.diagnosis.slice(0,10) }}...
                  <template #body>{{rowData.diagnosis}}</template>
                </VaPopover>
                <span v-else>{{ rowData.diagnosis }}</span>
              </template>
              <template #cell(operationName)="{ rowData }">
                <VaPopover placement="right" v-if="rowData.operationName.length>12" style="max-width:50vw">
                  {{ rowData.operationName.slice(0,10) }}...
                  <template #body>{{rowData.operationName}}</template>
                </VaPopover>
                <span v-else>{{ rowData.operationName }}</span>
              </template>
              <template #cell(patient_sex)="{ rowData }">{{ sex_str[rowData.patient_sex] }}</template>
              <template #cell(patient_villager)="{ rowData }"> {{ rowData.patient_villager === "True" ? 'Да' : "Нет" }} </template>
              <template #cell(paid)="{ rowData }"> {{ rowData.paid == "True" ? 'Платный' : "Нет" }} </template>
            </VaDataTable>

            <VaPagination
              v-if="reportLength.operations>0 && pages.operations > 1"
              v-model="filter.operations.page"
              :pages="pages.operations"
              :visible-pages="3"
              buttons-preset="secondary"
              class="justify-center sm:justify-start"
            />
        </VaCardContent>
      </Transition>


  </VaCard>
</template>
<script>
import axiosInstance from "../services/api";
import EventBus from "../common/EventBus";
import { RouterLink } from 'vue-router'
import PatientProfile from '@/components/PatientProfile';
import debounce from 'lodash.debounce'
import { formatDate } from "@/common/rcfx";
import { join } from "lodash";
import ExcelJS from "exceljs";
import logoUrl from '@/assets/logo_inline.png';

export default {
    components: { RouterLink, PatientProfile },
    data() {
        return {
            loading: false,
            ownfilter: [
              { label: "Все", value: false },
              { label: "Только мои", value: true },
            ],
            formOptions: [
              { label: "Табличная форма", value: false },
              { label: "Печатная форма", value: true },
            ],            
            options: [
              { text: "Не важно", value: -1 },
              { text: "Да", value: 1 },
              { text: "Нет", value: 0 },
            ],
            sexoptions: [
              { text: "Не важно", value: -1 },
              { text: "Мужской", value: "m" },
              { text: "Женский", value: "f" },
            ],
            columns: {
              visits:
              [
                { key: "id", label: "Номер", sortable: true, width: 1 },
                { key: "visitDate", label: "Дата приема", sortable: true, width: 10 },
                { key: "diagnosis", label: "Диагноз", sortable: true, width: 10 },
                { key: "mkb10", label: "МКБ-10", sortable: true, width: 10 },
                { key: "patient_full_name", label: "ФИО пациента", sortable: true, width: 10 },
                { key: "patient_age_at_visit", label: "Возраст", sortable: true, width: 10 },
                { key: "patient_sex", label: "Пол", sortable: true, width: 10 },
                { key: "patient_villager", label: "Сельский житель", sortable: true, width: 10 },
                { key: "paid", label: "Оплата", sortable: true, width: 10 },
              ],
              discharge:
              [
                { key: "id", label: "Номер", sortable: true, width: 1 },
                { key: "discharge_date", label: "Дата выписки", sortable: true, width: 10 },
                { key: "diagnosis", label: "Диагноз", sortable: true, width: 10 },
                // { key: "mkb10", label: "МКБ-10", sortable: true, width: 10 },
                { key: "patient_full_name", label: "ФИО пациента", sortable: true, width: 10 },
                { key: "patient_age_at_discharge", label: "Возраст", sortable: true, width: 10 },
                { key: "patient_sex", label: "Пол", sortable: true, width: 10 },
                { key: "patient_villager", label: "Сельский житель", sortable: true, width: 10 },
                { key: "paid", label: "Оплата", sortable: true, width: 10 },
              ],
              journal:
              [
                { key: "id", label: "Номер", sortable: true, width: 1 },
                { key: "openDate", label: "Дата поступления", sortable: true, width: 10 },
                { key: "discharge_date", label: "Дата выписки", sortable: true, width: 10 },
                { key: "clinic_days", label: "Кол-во койко-дней", sortable: true, width: 10 },
                { key: "patient_full_name", label: "ФИО пациента", sortable: true, width: 10 },
                { key: "diagnosis", label: "Диагноз", sortable: true, width: 10 },
                { key: "operationCode", label: "Код операции", sortable: true, width: 10 },
                { key: "operationCodeKSG", label: "Код КСГ", sortable: true, width: 10 },
                { key: "operationName", label: "Название операции", sortable: true, width: 10 },
                { key: "xray_image", label: "Дата снимка", sortable: true, width: 10 },
                { key: "doctor_full_name", label: "Лечащий врач", sortable: true, width: 10 },
                { key: "operator_full_name", label: "Оператор", sortable: true, width: 10 },
                { key: "patient_age_at_discharge", label: "Возраст", sortable: true, width: 10 },
                { key: "patient_sex", label: "Пол", sortable: true, width: 10 },
                { key: "patient_villager", label: "Сельский житель", sortable: true, width: 10 },
                { key: "paid", label: "Оплата", sortable: true, width: 10 },
              ],
              operations:
              [
                { key: "id", label: "Внутренний", sortable: true, width: 1 },
                { key: "operationNo", label: "Номер операции", sortable: true, width: 1 },
                { key: "operationEnd", label: "Дата операции", sortable: true, width: 10 },
                { key: "patient_full_name", label: "ФИО пациента", sortable: true, width: 10 },
                { key: "patient_sex", label: "Пол", sortable: true, width: 10 },
                { key: "patient_villager", label: "Сельский житель", sortable: true, width: 10 },
                { key: "diagnosis", label: "Диагноз", sortable: true, width: 10 },
                { key: "operationCode", label: "Код операции", sortable: true, width: 10 },
                { key: "operationCodeKSG", label: "Код КСГ", sortable: true, width: 10 },
                { key: "operationName", label: "Название операции", sortable: true, width: 10 },
                { key: "operator_full_name", label: "Оператор", sortable: true, width: 10 },
                { key: "paid", label: "Оплата", sortable: true, width: 10 },
              ],
            },
            itemsPerPage: 20,
            pages:1,
            page:1,
            visits: [],
            selectedVisit: 0,
            patient: {},
            filter: 'open',
            myown: false,
            showVisitModal: false,
            printForm: true,
            printWindow: false,
            prev: String,
            next: String,
            query: '',
            filter: {
              visits: {
                sex: -1,
                paid: -1,
                villager: -1,
                dateMin: new Date(2024,3,1),
                dateMax: new Date(),
                age:[18,70],
                page: 1,
              },
              discharge: {
                sex: -1,
                paid: -1,
                villager: -1,
                dateMin: new Date(2024,3,1),
                dateMax: new Date(),
                age:[18,70],
                page: 1,
              },
              journal: {
                code: "",
                ksg: "",
                sex: -1,
                paid: -1,
                villager: -1,
                dateMin: new Date(2024,3,1),
                dateMax: new Date(),
                age:[18,70],
                page: 1,
              },
              operations: {
                code: "",
                ksg: "",
                sex: -1,
                paid: -1,
                villager: -1,
                dateMin: new Date(2024,3,1),
                dateMax: new Date(),
                age:[18,70],
                page: 1,
              },
            },
            actualFilters: {},
            codes: {},
            reportVisits: {},
            reportDischarge: {},
            reportJournal: {},
            reportOperations: {},
            reportLength: {
              visits: 0,
              discharge: 0,
              journal: 0,
              operations: 0,
            },
            page: {
              visits: 1,
              discharge: 1,
              journal: 1,
              operations: 1,
            },
            pages: {
              visits: 0,
              discharge: 0,
              journal: 0,
              operations: 0,
            },
            reportType: 0,
            et: [0,0,0,0],
            sex_str: {"m":"М", "f":"Ж"},
            time: {
              start: '',
              end: '',
            },
            start:'',
            end:'',
            slideDirection: "slide-left",
            // Названия столбцов - отчет Амбулаторные приемы
            headers_amb: {
              id: "Номер",
              visitDate: "Дата приема",
              diagnosis: "Диагноз",
              mkb10: "МКБ-10",
              patient_full_name: "ФИО пациента",
              patient_age_at_visit: "Возраст",
              patient_sex: "Пол",
              patient_villager: "Сельский житель",
              paid: "Платный"
            },
            headers_dis: {
              id: "Номер",
              discharge_date: "Дата выписки",
              diagnosis: "Диагноз",
              patient_full_name: "ФИО пациента",
              patient_age_at_discharge: "Возраст",
              patient_sex: "Пол",
              patient_villager: "Сельский житель",
              paid: "Платный"
            },
            headers_journal: {
              id: "Номер",
              openDate: "Дата поступления",
              discharge_date: "Дата выписки",
              clinic_days: "Кол-во койко-дней",
              patient_full_name: "ФИО пациента",
              diagnosis: "Диагноз",
              operationCode: "Код операции",
              operationCodeKSG: "Код КСГ",
              operationName: "Название операции",
              xray_image: "Дата снимка",
              doctor_full_name: "Лечащий врач",
              operator_full_name: "Оператор",
              patient_age_at_discharge: "Возраст",
              patient_sex: "Пол",
              patient_villager: "Сельский житель",
              paid: "Платный"
            },
            headers_operations: {
              id: "Внутренний номер",
              operationNo: "Номер операции",
              operationEnd: "Дата операции",
              patient_full_name: "ФИО пациента",
              patient_sex: "Пол",
              patient_villager: "Сельский житель",
              diagnosis: "Диагноз",
              operationCode: "Код операции",
              operationCodeKSG: "Код КСГ",
              operationName: "Название операции",
              operator_full_name: "Оператор",
              paid: "Платный",
            },
            isExporting: false,
          };
    },
    computed: {
      pageVisits() {
        return this.filter.visits.page
      },
      pageDischarge() {
        return this.filter.discharge.page
      },
      pageJournal() {
        return this.filter.journal.page
      },
      pageOperations() {
        return this.filter.operations.page
      },
      ownfiltered() {
        if (this.filter === 'all') {
          return this.filtered
        }
        if (this.filter === 'myown') {
          return this.filtered.filter(item => item.user === this.$store.state.app.account.profile.id)
        }
      },
      tooShortQuery() {
        return this.query.length !== 0 && this.query.length<3 ? true : false 
      },
      age() {
        return this.filter.age
      }
    },
    watch: {
      pageVisits(value) {
        this.getReportVisits()
      },
      pageDischarge(value) {
        this.getReportDischarge()
      },
      pageJournal(value) {
        this.getReportJournal()
      },
      pageOperations(value) {
        this.getReportOperations()
      },
      end(value) {
        if (value>0) {
          this.et[this.reportType] = (this.end - this.start)/1000
        }
      },
      reportType(newValue,oldValue) {
        if (newValue===2) {
          this.getCodes()
        }
        if (newValue < oldValue) {
          this.slideDirection = "slide-right"
        } else {
          this.slideDirection = "slide-left"
        }
      },
      query: function (newValue) {
        if (!this.tooShortQuery) {
          this.debouncedSearch()
        }
      },
      myown() {
        this.getVisits(true,this.query)
      },
      page(value) {
        this.getVisits(false,this.query)
      }
    },
    methods: {

      async getReportFile(sourceData, headers) {
          let reportName
          switch(this.reportType){
            case 0:
              reportName = "Амбулаторные приемы"
              break
            case 1:
              reportName = "Выписки"
              break
            case 2:
              reportName = "Стационарный журнал"
              break
            case 3:
              reportName = "Журнал операций"
          }

          const dateFields = ['operationEnd', 'openDate', 'discharge_date','visitDate'];

          const formattedData = sourceData.map(item =>
              this.formatDates(item, dateFields)
          );
            
          // Преобразование значений для отображения в отчёте
          const formatFields = (value) => {
              if (value === true || value === "true" || value === "True") return "Да";
              if (value === false || value === "false" || value === "False") return "Нет";
              if (value === "f") return "Женский";
              if (value === "m") return "Мужской";
              if (value instanceof Object) {
                  if (value.hasOwnProperty("image")) {
                      return value.date;
                  }
              }
              // if (value instanceof Date) {
              //   return value.toLocaleDateString()
              // }
              return value;
          };
          // Оставляем только разрешённые поля
          const allowedKeys = Object.keys(headers)

          const filteredData = formattedData.map(row =>
            Object.fromEntries(
              allowedKeys
                .filter(key => Object.prototype.hasOwnProperty.call(row, key))
                .map(key => [key, row[key]])
            )
          )
          // Подготовка данных с преобразованием значений
          const data = filteredData.map(item =>
              Object.fromEntries(
                  Object.entries(item).map(([key, value]) => [
                      headers[key] || key,
                      formatFields(value)
                  ])
              )
          );

          // Создание книги Excel и листа
          const workbook = new ExcelJS.Workbook();

          // Атрибуты авторства и дат
          workbook.creator = 'Реактив.Клиник';
          workbook.lastModifiedBy = 'Реактив.Клиник';
          workbook.created = new Date();
          workbook.modified = new Date();

          // Атрибуты: название, категории, тема
          workbook.title = reportName;
          workbook.category = 'Медицинские отчёты';
          workbook.subject = `Отчёт: ${reportName} за период ${this.actualFilters.dateMin.toLocaleDateString()} - ${this.actualFilters.dateMax.toLocaleDateString()}`;

          const worksheet = workbook.addWorksheet(reportName);


          // Отдельная верхняя строка для логотипа
          worksheet.addRow([])
          worksheet.getRow(1).height = 45

          // Добавление логотипа
          const logoBase64 = await fetch(logoUrl)
            .then(response => response.blob())
            .then(blob => new Promise((resolve, reject) => {
              const reader = new FileReader()

              reader.onload = () => {
                resolve(reader.result.split(',')[1])
              }

              reader.onerror = reject
              reader.readAsDataURL(blob)
            }))

          const imageId = workbook.addImage({
            base64: logoBase64,
            extension: 'png',
          })

          const width = 200
          const height = width * (150 / 899)

          worksheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width, height },
            editAs: 'oneCell'
          })

          // Получение названий столбцов из данных
          const columns = Object.keys(data[0] || {});

          // Настройка столбцов без автоматического создания заголовков
          worksheet.columns = columns.map(key => ({
            key: key,
            width: key === "Диагноз" ? 50 : 15
          }))
         
          // Заголовки во второй строке
          const headerRow = worksheet.getRow(2)
          headerRow.values = columns
          
          // Добавление строк с данными
          data.forEach(item => {
              worksheet.addRow(item);
          });
          

          // Цвета чередующихся строк: белый и светло-голубой
          const rowColors = ["FFFFFFFF", "FFEDF3F8"];

          // Оформление ячеек таблицы
          worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
              row.eachCell({ includeEmpty: true }, cell => {
                  if (rowNumber === 2) {
                      // Стилизация заголовков
                      cell.font = {
                          bold: true,
                          color: { argb: "FFFFFFFF" }
                      };

                      cell.fill = {
                          type: "pattern",
                          pattern: "solid",
                          fgColor: { argb: "FF4472C4" }
                      };

                      cell.alignment = {
                          horizontal: "center",
                          vertical: "middle",
                          wrapText: true
                      };

                      // Более толстые верхняя и нижняя границы шапки
                      cell.border = {
                          top: {
                              style: "medium",
                              color: { argb: "FF2F5597" }
                          },
                          bottom: {
                              style: "medium",
                              color: { argb: "FF2F5597" }
                          },
                          left: {
                              style: "thin",
                              color: { argb: "FF2F5597" }
                          },
                          right: {
                              style: "thin",
                              color: { argb: "FF2F5597" }
                          }
                      };
                  } else if(rowNumber > 2) {
                      // Чередование цветов строк
                      cell.fill = {
                          type: "pattern",
                          pattern: "solid",
                          fgColor: {
                              argb: rowColors[(rowNumber - 2) % rowColors.length]
                          }
                      };

                      // Границы всех ячеек с данными
                      cell.border = {
                          top: {
                              style: "thin",
                              color: { argb: "FFB4C7E7" }
                          },
                          bottom: {
                              style: "thin",
                              color: { argb: "FFB4C7E7" }
                          },
                          left: {
                              style: "thin",
                              color: { argb: "FFB4C7E7" }
                          },
                          right: {
                              style: "thin",
                              color: { argb: "FFB4C7E7" }
                          }
                      };

                      // Выравнивание данных по верхнему краю
                      cell.alignment = {
                          vertical: "top"
                      };
                  }
              });

              // Высота строк: шапка 30, строки данных 60 пунктов
              row.height = rowNumber === 2 ? 30 : 60;
          });

          // Автоматическая ширина столбцов
          worksheet.columns.forEach(column => {
              const key = column.key;

              if (key === "Диагноз" || key === "Название операции") {
                  column.width = 50;
              } else if (key === "МКБ-10") {
                  column.width = 35;
              } else {
                  const maxLength = Math.max(
                      String(column.header || "").length,
                      ...data.map(row => String(row[key] ?? "").length)
                  );

                  column.width = Math.max(maxLength + 2, 10);
              }
          });

          // Перенос текста в столбце «Диагноз»
          const diagnosisCol = columns.indexOf("Диагноз") + 1;

          if (diagnosisCol > 0) {
              worksheet.getColumn(diagnosisCol).eachCell(cell => {
                  cell.alignment = {
                      ...cell.alignment,
                      wrapText: true,
                      vertical: "middle"
                  };
              });
          }

          // Перенос текста в столбце «Название операции»
          const operationNameCol = columns.indexOf("Название операции") + 1;

          if (operationNameCol > 0) {
              worksheet.getColumn(operationNameCol).eachCell(cell => {
                  cell.alignment = {
                      ...cell.alignment,
                      wrapText: true,
                      vertical: "top"
                  };
              });
          }

          // Автофильтры для всех столбцов заголовка
          if (columns.length > 0) {
              worksheet.autoFilter = {
                  from: { row: 2, column: 1 },
                  to: { row: 2, column: columns.length }
              };
          }

          // Закрепление первой строки
          worksheet.views = [
              {
                  state: "frozen",
                  ySplit: 2,
                  topLeftCell: "A3",
                  activePane: "bottomLeft"
              }
          ];

          // Маркировка даты и времени формирования отчёта
          const lastDataRow = worksheet.rowCount
          const markRowNumber = lastDataRow + 2 // одна пустая строка

          const markRow = worksheet.getRow(markRowNumber)
          const now = new Date()

          const reportDateTime = now.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          })

          const markText = `Отчёт сгенерирован в Реактив.Клиник: ${reportDateTime}`

          // Объединяем ячейки маркировки по ширине таблицы
          const columnCount = worksheet.columnCount

          if (columnCount > 1) {
            worksheet.mergeCells(
              markRowNumber,
              1,
              markRowNumber,
              columnCount
            )
          }

          // Объединяем ячейки первой строки
          if (columnCount > 1) {
            worksheet.mergeCells(1, 1, 1, columnCount)
          }

          // Название отчёта
          const titleCell = worksheet.getCell('A1')
          titleCell.value = reportName + ' за период ' + this.actualFilters.dateMin.toLocaleDateString() + ' - ' + this.actualFilters.dateMax.toLocaleDateString()

          titleCell.font = {
            bold: true,
            size: 16,
            color: { argb: 'FF404040' }
          }

          titleCell.alignment = {
            horizontal: 'left',
            vertical: 'bottom'
          }

          titleCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
          }

          titleCell.border = {
            top: { style: 'thin', color: { argb: 'FFB4C7E7' } },
            bottom: { style: 'thin', color: { argb: 'FFB4C7E7' } },
            left: { style: 'thin', color: { argb: 'FFB4C7E7' } },
            right: { style: 'thin', color: { argb: 'FFB4C7E7' } }
          }

          const markCell = markRow.getCell(1)
          markCell.value = {
            text: markText,
            hyperlink: 'https://reactiv.su'
          }

          // Оформление маркировки
          markCell.font = {
            italic: true,
            size: 10,
            color: { argb: 'FF404040' },
            underline: true,
          }

          markCell.alignment = {
            horizontal: 'left',
            vertical: 'middle'
          }

          markCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
          }

          markCell.border = {
            top: { style: 'thin', color: { argb: 'FF808080' } },
            bottom: { style: 'thin', color: { argb: 'FF808080' } },
            left: { style: 'thin', color: { argb: 'FF808080' } },
            right: { style: 'thin', color: { argb: 'FF808080' } }
          }

          markRow.height = 24


          // Формирование XLSX-файла
          const buffer = await workbook.xlsx.writeBuffer();

          // Создание файла для скачивания в браузере
          const blob = new Blob(
              [buffer],
              {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              }
          );

          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");

          const date = new Date();

          const reportDate = date.toLocaleDateString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });

          link.href = url;
          link.download = reportName.split(" ").join("_") + "_от_" + reportDate + ".xlsx";

          document.body.appendChild(link);
          link.click();
          link.remove();

          // Освобождение временного URL после запуска скачивания
          setTimeout(() => URL.revokeObjectURL(url), 1000);
      },

      datetimeToDate(value) {
        if (!value) return value;

        const dateString = String(value).trim();

        // Уже в формате dd.mm.YYYY или dd.mm.YYYY HH:mm:ss
        const ruDate = dateString.match(
            /^(\d{2})\.(\d{2})\.(\d{4})(?:\s+\d{2}:\d{2}:\d{2})?$/
        );

        if (ruDate) {
            return `${ruDate[1]}.${ruDate[2]}.${ruDate[3]}`;
        }

        // ISO-подобные форматы:
        // 2026-02-18 06:42:10+00:00
        // 2026-02-11 10:25:31.305000+00:00
        // 2026-02-18T06:42:10.000Z
        // 2026-02-18
        const isoDate = dateString.match(
            /^(\d{4})-(\d{2})-(\d{2})(?=$|[T\s])/
        );

        if (isoDate) {
            return `${isoDate[3]}.${isoDate[2]}.${isoDate[1]}`;
        }

        // Неизвестный формат — возвращаем исходное значение
        return value;
      },

      formatDates(data, fields) {
        if (!data || typeof data !== 'object') return data;

        const result = { ...data };

        fields.forEach(field => {
            if (field in result) {
                result[field] = this.datetimeToDate(result[field]);
            }
        });

        return result;
      },

      wordforcount(value, words) {
        value = Math.abs(value) % 100; 
        var num = value % 10;
        if(value > 10 && value < 20) return words[2]; 
        if(num > 1 && num < 5) return words[1];
        if(num == 1) return words[0]; 
        return words[2];
      },

      buildQuery() {
        this.actualFilters = {}
        var filter
        if (this.reportType===0) {
          filter = this.filter.visits
        } else if (this.reportType === 1) {
          filter = this.filter.discharge
        } else if (this.reportType === 2) {
          filter = this.filter.journal
        } else if (this.reportType === 3) {
          filter = this.filter.operations 
        }
        this.actualFilters = filter
        var q = []
        q.push("dateMin=" + filter.dateMin.toLocaleDateString())
        q.push("dateMax=" + filter.dateMax.toLocaleDateString())
        q.push("ageMin=" + filter.age[0])
        q.push("ageMax=" + filter.age[1])
        filter.villager >= 0 && q.push("villager=" + filter.villager)
        filter.paid >= 0 && q.push("paid=" + filter.paid)
        filter.code !== "" && q.push("code=" + filter.code)
        filter.ksg !== "" && q.push("ksg=" + filter.ksg)
        typeof(filter.sex)==="string" && q.push("sex=" + filter.sex)
        filter.page >= 0 && q.push("page=" + filter.page)

        return '?' + q.join('&')
      },
      async print(elid, wait=false) {
        if (wait) {
          await this.showVisitModal && this.$htmlToPaper(elid, null, () => {this.$refs.VisitDetailsModal.hide()});
        }else{
          await this.$htmlToPaper(elid);
        }
      },
      printDocument() {
        this.printWindow = !this.printWindow
      },
      resetSearch() {
        this.query=""
        this.getVisits(true,false)
      },
      debouncedSearch: debounce(function () {
              this.getVisits(true, this.query);
            }, 600),

      async downloadReport() {
        if (this.reportType===0) {
          try {
            console.log('Downloading amb report...')
            this.isExporting = true

            let sourceData = await this.getAllReportVisits()

            await this.getReportFile(sourceData, this.headers_amb)
          } catch (error) {
            console.error('Ошибка скачивания отчёта:', error)
          } finally {
            this.isExporting = false
          }
        } else if (this.reportType===1) {
          try {
            console.log('Downloading discharge report...')
            this.isExporting = true

            let sourceData = await this.getAllReportDischarge()

            await this.getReportFile(sourceData, this.headers_dis)
          } catch (error) {
            console.error('Ошибка скачивания отчёта:', error)
          } finally {
            this.isExporting = false
          }
        } else if (this.reportType===2) {
          try {
            console.log('Downloading journal report...')
            this.isExporting = true

            let sourceData = await this.getAllReportJournal()

            await this.getReportFile(sourceData, this.headers_journal)
          } catch (error) {
            console.error('Ошибка скачивания отчёта:', error)
          } finally {
            this.isExporting = false
          }
        } else if (this.reportType===3) {
          try {
            console.log('Downloading operations report...')
            this.isExporting = true

            let sourceData = await this.getAllReportOperations()

            await this.getReportFile(sourceData, this.headers_operations)
          } catch (error) {
            console.error('Ошибка скачивания отчёта:', error)
          } finally {
            this.isExporting = false
          }
        }
      },

      getAllReportVisits() {
        this.isExporting = true

        return axiosInstance
          .get('report/visits' + this.buildQuery() + '&paginate=false')
          .then(response => {
            return response.data
          })
          .catch(error => {
            console.error('Ошибка получения отчёта:', error)
            throw error
          })
          .finally(() => {
            this.isExporting = false
          })
      },
      getReportVisits(resetpage=false, paginate=true) {
        resetpage && (this.filter.visits.page=1)
        this.end = 0
        this.start = new Date().getTime()
        this.loading = true
        axiosInstance
        .get('report/visits' + this.buildQuery() + (paginate ? '' : '&paginate=false'))
        .then(response => {
          this.end = new Date().getTime()
          var data = response.data
          this.pages.visits = Math.ceil(data.count / 20)
          // this.page.visits = 1
          this.reportLength.visits = data.count
          this.reportVisits = data.results ? data.results : data
          // this.reportVisits = data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
      },
      getAllReportDischarge() {
        this.isExporting = true

        return axiosInstance
          .get('report/discharge' + this.buildQuery() + '&paginate=false')
          .then(response => {
            return response.data
          })
          .catch(error => {
            console.error('Ошибка получения отчёта:', error)
            throw error
          })
          .finally(() => {
            this.isExporting = false
          })
      },
      getReportDischarge(resetpage=false, paginate=true) {
        resetpage && (this.filter.discharge.page=1)
        this.end = 0
        this.start = new Date().getTime()
        this.loading = true
        axiosInstance
        .get('report/discharge' + this.buildQuery())
        .then(response => {
          this.end = new Date().getTime()
          var data = response.data
          this.pages.discharge = Math.ceil(data.count / 20)
          // this.page.discharge = 1
          this.reportLength.discharge = data.count
          this.reportDischarge = data.results
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
      },
      getAllReportJournal() {
        this.isExporting = true

        return axiosInstance
          .get('report/journal' + this.buildQuery() + '&paginate=false')
          .then(response => {
            return response.data
          })
          .catch(error => {
            console.error('Ошибка получения отчёта:', error)
            throw error
          })
          .finally(() => {
            this.isExporting = false
          })
      },
      getReportJournal(resetpage=false) {
        resetpage && (this.filter.journal.page=1)
        this.end = 0
        this.start = new Date().getTime()
        this.loading = true
        axiosInstance
        .get('report/journal' + this.buildQuery())
        .then(response => {
          this.end = new Date().getTime()
          var data = response.data
          this.pages.journal = Math.ceil(data.count / 20)
          this.page.journal = 1
          this.reportLength.journal = data.count
          this.reportJournal = data.results
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
      },
      getAllReportOperations() {
        this.isExporting = true

        return axiosInstance
          .get('report/operations' + this.buildQuery() + '&paginate=false')
          .then(response => {
            return response.data
          })
          .catch(error => {
            console.error('Ошибка получения отчёта:', error)
            throw error
          })
          .finally(() => {
            this.isExporting = false
          })
      },
      getReportOperations(resetpage=false) {
        resetpage && (this.filter.operations.page=1)
        this.end = 0
        this.start = new Date().getTime()
        this.loading = true
        axiosInstance
        .get('report/operations' + this.buildQuery())
        .then(response => {
          this.end = new Date().getTime()
          var data = response.data
          this.pages.operations = Math.ceil(data.count / 20)
          this.page.operations = 1
          this.reportLength.operations = data.count
          this.reportOperations = data.results
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })
      },
      getCodes() {
        this.loading = true
        axiosInstance
        .get('report/codes')
        .then(response => {
          var data = response.data
          this.codes = data.results
          this.loading = false
        })
        .catch(error => {
          this.loading = false
        })

      },
    },
    created() {
      !this.$store.state.auth.status.loggedIn && this.$router.push('/login')
    },
    mounted() {
    },
}

</script>
<style>
.slide-left-leave-active,
.slide-right-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-left-enter-active,
.slide-right-enter-active {
  margin-top:20px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.slide-left-enter-from,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(1200px);
}
.slide-left-leave-to,
.slide-right-enter-from {
  opacity: 0;
  transform: translateX(-1200px);
}
.slide-left-leave-active,
.slide-right-leave-active {
  position:absolute;
}

</style>